export default __webpack_public_path__ + "static/media/post-suvinil10.44691949.png";